import React from 'react'

import { Menu } from '@/components/navigation/Menu'

import { sections, playbookTitlesSectionMap, accessorSectionMap } from '../playbook.helpers'

const tabs = [
  { route: sections.CHECKLIST, title: playbookTitlesSectionMap[sections.CHECKLIST] },
  { route: sections.DYNAMIC_PROMPT, title: playbookTitlesSectionMap[sections.DYNAMIC_PROMPT] },
  { route: sections.STICKY_NOTE, title: playbookTitlesSectionMap[sections.STICKY_NOTE] },
  { route: sections.POSTCALL, title: playbookTitlesSectionMap[sections.POSTCALL] },
]

export const PlaybookTabs = ({ playbookId, section, validationError }) => {
  return (
    <Menu
      className="playbook-tabs mb"
      items={tabs.map((tab) => {
        const isActive = section === tab.route
        const hasValidationError = validationError?.accessor === accessorSectionMap[tab.route]

        return {
          accessor: tab.route,
          label: tab.title,
          to: `/playbooks/${playbookId}/${tab.route}`,
          dataTestId: `playbook-tabs-${tab.route}-${isActive ? 'active' : 'inactive'}`,
          badge: hasValidationError ? 1 : undefined,
          badgeProps: { className: 'critical' },
        }
      })}
    />
  )
}
